import React, { useState, useEffect, useCallback } from "react";
import { Container, Row, Col, Button, Modal, Form } from "react-bootstrap";
import { CopyToClipboard } from "react-copy-to-clipboard";
import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  EmailShareButton,
  FacebookIcon,
  TwitterIcon,
  LinkedinIcon,
  EmailIcon,
} from "react-share";
import "./blog.css";
import { format } from "date-fns";
import { useAcubeService } from "../../service/acube-api.hook";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../context/app-context";
import TestimonialCarousel from "../../components/carousels/testimonial-carousel";
import TestimonialVideoPlayer from "../../components/videos/testimonial-video";
import ContactForm from "../../components/forms/contact-form";
import ProductPartners from "../../components/product-partners";
import _ from "lodash";
import SearchResults from "./search-blog";
import Skeleton from "react-loading-skeleton";
import SkeletonScreen from "../../components/Skeleton/Skeleton";
import { API_BASE_URL, APP_DOMAIN } from "../../utils/env";
import axios from "axios";
import SentryVideoTestimonial from "../../components/videos/sentry-video";

const like =
  "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/blogs/thumbs-up-unfilled.svg";
const likeFilled =
  "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/blogs/thumbs-up-filled.svg";
const share =
  "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/blogs/share-icon.svg";
const search =
  "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/blogs/search-btn.svg";
const copyLink =
  "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/blogs/link.svg";
const copySuccess =
  "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/blogs/copied.svg"; // Success tick icon
const closeIcon =
  "https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/close-menu.svg";
const tags = [
  "Artificial Intelligence",
  "Machine Learning",
  "Blockchain",
  "UIUX",
  "IOT",
  "Web 3.0",
];

const BlogComponent = () => {
  const [showModal, setShowModal] = useState(false);
  const [currentBlog, setCurrentBlog] = useState(null);
  const [isCopied, setIsCopied] = useState(false); // State to track if the link is copied
  const { getProxy, postProxy } = useAcubeService();
  const [blogData, setBlogData] = useState([]);
  const { ipAddress } = useAppContext();
  const [isSearched, setIsSearched] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [selectedTags, setSelectedTags] = useState([]);

  const navigate = useNavigate();
  const handleShareClick = (blog) => {
    setCurrentBlog(blog);
    setShowModal(true);
    setIsCopied(false); // Reset copy state when modal opens
  };

  const handleCloseModal = () => setShowModal(false);

  const shareURL = currentBlog
    ? `${APP_DOMAIN}/resources/article/${currentBlog.slug}`
    : "";

  const socialMediaLinks = {
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${shareURL}`,
    twitter: `https://twitter.com/intent/tweet?url=${shareURL}`,
    linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=${shareURL}`,
    email: `mailto:?subject=Check out this blog&body=Read this blog: ${shareURL}`, // Correct email URL
  };

  const handleCopy = () => {
    setIsCopied(true); // Change state to indicate the link is copied
  };
  const fetchBlogs = async () => {
    const result = await getProxy(`blog/limited-blogs/${ipAddress}`);
    setBlogData(result.data);
    setIsLoading(false);

    // await getProxy(`blog/popular/${ipAddress}`);
    // await getProxy(`blog/most-viewed/${ipAddress}`);
    // await getProxy(`blog/recent/${ipAddress}`);
  };
  useEffect(() => {
    if (ipAddress) {
      setIsLoading(true);

      fetchBlogs();
    }
  }, [ipAddress]); // Dependency array is empty, so this effect runs only once after the initial render

  // Format the date to "13 March 2024"
  const formatDate = (dateString) => {
    return format(new Date(dateString), "d MMMM yyyy");
  };
  const addViewsCount = async (uuid) => {
    try {
      const payload = { blogUUID: uuid };
      await postProxy(`blog/views`, payload);
    } catch (error) {
      console.error("Error adding view count:", error);
    }
  };
  const handleBlogClick = (blog) => {
    addViewsCount(blog.blog_uuid);
    navigate(`/resources/article/${blog.slug}`);
  };
  const handleLikeClick = (blog) => {
    const payload = {
      blogUUID: blog.blog_uuid,
      ip: ipAddress,
    };

    postProxy(`blog/like`, payload)
      .then(async () => {
        fetchBlogs();
      })
      .catch((err) => {
        console.log("Error liking blog:", err);
      });
  };
  const handleViewClick = (viewtype) => {
    navigate(`/resources/article/viewall/${viewtype}`);
  };
  const handleCategoryClick = (type) => {
    const formattedType = type.replace(/\s+/g, "-");
    navigate(`/resources/article/category/${formattedType}`);
  };

  const debouncedHandleSearch = useCallback(
    _.debounce(async (searchValue, ip) => {
      await getProxy(`blog/search/${searchValue}/${ip}`)
        .then((result) => {
          setIsLoading(false);
          setBlogData(result);
          setSelectedTags([]);
        })
        .catch(() => {
          setIsLoading(false);
        });
    }, 1000),
    []
  );

  const handleInputChange = (e) => {
    const { value } = e.target;
    setIsSearched(true);
    setIsLoading(true);
    setSearchInput(value);
    setSelectedTags([]);

    // Cancel the previous debounce if the value changes or is empty
    if (!value) {
      debouncedHandleSearch.cancel();
      // hanleSearchClose();
    }
    if (value.length > 1) {
      debouncedHandleSearch(value, ipAddress);
    } else if (value.length === 0) {
      hanleSearchClose();
    }
  };
  const hanleSearchClose = () => {
    setIsSearched(false);
    setIsLoading(false);
    setSearchInput("");
    fetchBlogs();
  };
  const fetchBlogsByTags = async (selectedTagsByProps = selectedTags) => {
    try {
      const response = await axios.get(`${API_BASE_URL}blog/blogs-by-tags`, {
        params: {
          tags: selectedTagsByProps.join(","),
          ip: ipAddress, // Send ip address as a parameter
        }, // Send tags as comma-separated string
      });
      setIsLoading(false);
      setIsSearched(true);
      setBlogData(response.data);
    } catch (error) {
      console.error("Error fetching blogs by tags:", error);
    }
  };

  // Handle tag selection
  const handleTagChange = (tag) => {
    setSearchInput("");
    setSelectedTags((prevTags) => {
      const updatedTags = prevTags.includes(tag)
        ? prevTags.filter((t) => t !== tag)
        : [...prevTags, tag];

      // Fetch blogs after updating the state
      if (updatedTags.length) {
        setIsLoading(true);
        fetchBlogsByTags(updatedTags);
        setIsSearched(true);
      } else {
        fetchBlogs();
        setIsSearched(false);
      }

      return updatedTags;
    });
  };

  return (
    <section className="blog-container">
      <Container fluid className="pb-5 pt-3">
        <h2 className="text-primary ft-wt-700 mb-3 mt-0">Articles</h2>
        <div className="search-bar">
          <input
            type="text"
            placeholder="Search for articles, blogs, etc."
            onChange={handleInputChange}
            value={searchInput}
          />
          <img
            src={isSearched && searchInput ? closeIcon : search}
            alt="search"
            onClick={() => isSearched && hanleSearchClose()}
            className={`${isSearched ? "cursor-pointer" : ""}`}
          />
        </div>
        <div className="tags-container">
          {tags.map((tag, index) => (
            <div
              key={index}
              className={`tag ${selectedTags.includes(tag) ? "active" : ""}`}
              onClick={() => handleTagChange(tag)}
            >
              {tag}
              {selectedTags.includes(tag) && (
                <div className="d-flex">
                  <img
                    src="https://acube-s3.s3.us-east-1.amazonaws.com/Acube-portfolio/Images/blogs/circle-close.svg"
                    alt="circle-close"
                  />
                </div>
              )}
            </div>
          ))}
        </div>
        {isLoading ? (
          <SkeletonScreen />
        ) : isSearched ? (
          <SearchResults
            keyword={searchInput}
            blogs={blogData}
            setBlogData={setBlogData}
            selectedTags={selectedTags}
            fetchBlogsByTags={fetchBlogsByTags}
          />
        ) : (
          <>
            <div className="d-flex justify-content-between align-items-center">
              <h2 className="ft-wt-700 mb-0">What's New</h2>
              <div>
                <Button
                  className="p-0 text-primary ft-16"
                  variant="link"
                  onClick={() => handleViewClick("recent")}
                >
                  View All
                </Button>
              </div>
            </div>
            <Row className="blog-cards">
              {blogData?.recentBlogs?.length ? (
                blogData?.recentBlogs?.map((blog) => (
                  <Col
                    xs="12"
                    lg="4"
                    key={blog.id}
                    className="blog-card cursor-pointer"
                  >
                    <img
                      src={blog.template_image}
                      alt={blog.title}
                      className="blog-thumbnail"
                      onClick={() => handleBlogClick(blog)}
                    />
                    <div className="blog-card-info">
                      <div className="blog-meta">
                        <span
                          className="author"
                          onClick={() =>
                            handleCategoryClick(blog.service_category)
                          }
                        >
                          {blog.service_category}
                        </span>
                        <span className="date">
                          {formatDate(blog.created_at)}
                        </span>
                      </div>
                      <h3
                        className="blog-card-title"
                        onClick={() => handleBlogClick(blog)}
                      >
                        {blog.title}
                      </h3>
                      <p
                        className="blog-content"
                        onClick={() => handleBlogClick(blog)}
                      >
                        {blog.template_content}
                      </p>
                      <div className="blog-actions justify-content-between">
                        <div className="d-flex align-items-center gap-2">
                          <img
                            src={blog?.ip_logs?.length ? likeFilled : like}
                            alt="thumbs-up"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleLikeClick(blog);
                            }}
                          />
                          <img
                            src={share}
                            alt="share"
                            onClick={() => handleShareClick(blog)}
                          />
                        </div>
                        <div className="d-flex align-items-center gap-2">
                          <h6 className="mb-0">{blog.likesAdded} likes</h6>
                          <h6 className="mb-0">{blog.views} views</h6>
                        </div>
                      </div>
                    </div>
                  </Col>
                ))
              ) : (
                <SkeletonScreen />
              )}
            </Row>
            <div className="d-flex justify-content-between align-items-center mt-5">
              <h2 className="ft-wt-700 mb-0">Most Viewed</h2>
              <div>
                <Button
                  className="p-0 text-primary ft-16"
                  variant="link"
                  onClick={() => handleViewClick("most-viewed")}
                >
                  View All
                </Button>
              </div>
            </div>
            <Row className="blog-cards">
              {blogData?.mostViewedBlogs?.length ? (
                blogData?.mostViewedBlogs?.map((blog) => (
                  <Col
                    xs="12"
                    lg="4"
                    key={blog.id}
                    className="blog-card cursor-pointer"
                  >
                    <img
                      src={blog.template_image}
                      alt={blog.title}
                      className="blog-thumbnail"
                      onClick={() => handleBlogClick(blog)}
                    />
                    <div className="blog-card-info">
                      <div className="blog-meta">
                        <span
                          className="author"
                          onClick={() =>
                            handleCategoryClick(blog.service_category)
                          }
                        >
                          {blog.service_category}
                        </span>
                        <span className="date">
                          {formatDate(blog.created_at)}
                        </span>
                      </div>
                      <h3 className="blog-card-title">{blog.title}</h3>
                      <p className="blog-content">{blog.template_content}</p>
                      <div className="blog-actions justify-content-between">
                        <div className="d-flex align-items-center gap-2">
                          <img
                            src={blog?.ip_logs?.length ? likeFilled : like}
                            alt="thumbs-up"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleLikeClick(blog);
                            }}
                          />
                          <img
                            src={share}
                            alt="share"
                            onClick={() => handleShareClick(blog)}
                          />
                        </div>
                        <div className="d-flex align-items-center gap-2">
                          <h6 className="mb-0">{blog.likesAdded} likes</h6>
                          <h6 className="mb-0">{blog.views} views</h6>
                        </div>
                      </div>
                    </div>
                  </Col>
                ))
              ) : (
                <SkeletonScreen />
              )}
            </Row>
            <div className="d-flex justify-content-between align-items-center mt-5">
              <h2 className="ft-wt-700 mb-0">Popular Posts</h2>
              <div>
                <Button
                  className="p-0 text-primary ft-16"
                  variant="link"
                  onClick={() => handleViewClick("popular")}
                >
                  View All
                </Button>
              </div>
            </div>
            <Row className="blog-cards">
              {blogData?.popularBlogs?.length ? (
                blogData?.popularBlogs?.map((blog) => (
                  <Col
                    xs="12"
                    lg="4"
                    key={blog.id}
                    className="blog-card cursor-pointer"
                  >
                    <img
                      src={blog.template_image}
                      alt={blog.title}
                      className="blog-thumbnail"
                      onClick={() => handleBlogClick(blog)}
                    />
                    <div className="blog-card-info">
                      <div className="blog-meta">
                        <span
                          className="author"
                          onClick={() =>
                            handleCategoryClick(blog.service_category)
                          }
                        >
                          {blog.service_category}
                        </span>
                        <span className="date">
                          {formatDate(blog.created_at)}
                        </span>
                      </div>
                      <h3 className="blog-card-title">{blog.title}</h3>
                      <p className="blog-content">{blog.template_content}</p>
                      <div className="blog-actions justify-content-between">
                        <div className="d-flex align-items-center gap-2">
                          <img
                            src={blog?.ip_logs?.length ? likeFilled : like}
                            alt="thumbs-up"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleLikeClick(blog);
                            }}
                          />
                          <img
                            src={share}
                            alt="share"
                            onClick={() => handleShareClick(blog)}
                          />
                        </div>
                        <div className="d-flex align-items-center gap-2">
                          <h6 className="mb-0">{blog.likesAdded} likes</h6>
                          <h6 className="mb-0">{blog.views} views</h6>
                        </div>
                      </div>
                    </div>
                  </Col>
                ))
              ) : (
                <SkeletonScreen />
              )}
            </Row>
          </>
        )}
      </Container>

      {/* Modal for sharing */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title className="ft-wt-700">Share This Article</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3 text-center">
              <Form.Label>Share to</Form.Label>
              <div className="d-flex gap-2 justify-content-center">
                <FacebookShareButton
                  url={socialMediaLinks.facebook}
                  className="mr-2"
                >
                  <FacebookIcon size={48} round />
                </FacebookShareButton>
                <TwitterShareButton
                  url={socialMediaLinks.twitter}
                  className="mr-2"
                >
                  <TwitterIcon size={48} round />
                </TwitterShareButton>
                <LinkedinShareButton
                  url={socialMediaLinks.linkedin}
                  className="mr-2"
                >
                  <LinkedinIcon size={48} round />
                </LinkedinShareButton>
                <EmailShareButton url={socialMediaLinks.email} className="mr-2">
                  <EmailIcon size={48} round />
                </EmailShareButton>
              </div>
            </Form.Group>
            <Form.Group className="mb-3 position-relative">
              <Form.Label>Or copy the link</Form.Label>
              <div className="d-flex align-items-center">
                <Form.Control type="text" value={shareURL} readOnly />
                <CopyToClipboard text={shareURL} onCopy={handleCopy}>
                  <Button className="ms-2 p-0 copy-btn" variant="link">
                    <img
                      src={isCopied ? copySuccess : copyLink} // Change icon based on copy state
                      alt={isCopied ? "copied" : "copy"}
                      className="cursor-pointer"
                    />
                  </Button>
                </CopyToClipboard>
              </div>
              {isCopied && (
                <div className="link-success-msg">
                  Link copied successfully!
                </div>
              )}
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="link"
            className="ft-wt-700 text-primary text-decoration-none"
            onClick={handleCloseModal}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <TestimonialCarousel />
      <Container>
        <Row>
          <Col xs="12" lg="6">
            <TestimonialVideoPlayer />
          </Col>
          <Col xs="12" lg="6">
            <SentryVideoTestimonial />
          </Col>
        </Row>
      </Container>
      <ContactForm />
      <ProductPartners />
    </section>
  );
};

export default BlogComponent;
